import { render, staticRenderFns } from "./AddEditFormItem.vue?vue&type=template&id=3fe0b0d8&scoped=true&"
import script from "./AddEditFormItem.vue?vue&type=script&lang=js&"
export * from "./AddEditFormItem.vue?vue&type=script&lang=js&"
import style0 from "./AddEditFormItem.vue?vue&type=style&index=0&id=3fe0b0d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe0b0d8",
  null
  
)

export default component.exports